import { useEffect, useState } from 'react'

const logo = 'https://blueberry.azureedge.net/WillMars/willmars-logo-supplied.avif'

const navItems = [
  { href: '#about', id: 'about', label: 'About' },
  { href: '#markets', id: 'markets', label: 'Kenya & Tanzania' },
  { href: '#capabilities', id: 'capabilities', label: 'Capabilities' },
  { href: '#leadership', id: 'leadership', label: 'Leadership' },
  { href: '#faq', id: 'faq', label: 'FAQs' },
]

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [activeSection, setActiveSection] = useState('')

  useEffect(() => {
    const sectionIds = [...navItems.map((item) => item.id), 'contact']

    function update() {
      setIsScrolled(window.scrollY > 16)

      let current = ''
      sectionIds.forEach((id) => {
        const section = document.getElementById(id)
        if (section && section.getBoundingClientRect().top <= 140) {
          current = id
        }
      })
      setActiveSection(current)
    }

    window.addEventListener('scroll', update, { passive: true })
    update()
    return () => window.removeEventListener('scroll', update)
  }, [])

  function closeMenu() {
    setIsMenuOpen(false)
  }

  function scrollToTop(event) {
    event.preventDefault()
    closeMenu()
    const baseUrl = `${window.location.pathname}${window.location.search}`
    if (window.location.hash) {
      window.history.replaceState(null, '', baseUrl)
    }
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
  }

  return (
    <header className={isScrolled ? 'is-scrolled' : ''}>
      <nav className="wrap" aria-label="Main navigation">
        <a href="/" onClick={scrollToTop}>
          <img className="logo" src={logo} alt="WillMars Reinsurance Brokers" />
        </a>
        <div className={isMenuOpen ? 'links open' : 'links'}>
          {navItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className={activeSection === item.id ? 'is-active' : ''}
              onClick={closeMenu}
            >
              {item.label}
            </a>
          ))}
          <a
            className={activeSection === 'contact' ? 'nav-cta is-active' : 'nav-cta'}
            href="#contact"
            onClick={closeMenu}
          >
            Contact Us
          </a>
        </div>
        <button
          className={isMenuOpen ? 'menu is-open' : 'menu'}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    </header>
  )
}

export default Header
